export enum AddCategoryTourTypes {
  ADD_CATEGORY_TOUR_SUCCESS = 'ADD_CATEGORY_TOUR_SUCCESS',
  ADD_CATEGORY_TOUR_FAILURE = 'ADD_CATEGORY_TOUR_FAILURE',
  UPDATE_CATEGORY_TOUR_SUCCESS = 'UPDATE_CATEGORY_TOUR_SUCCESS',

  UPDATE_CATEGORY_TOUR_FAILURE = 'UPDATE_CATEGORY_TOUR_FAILURE',
}
export enum GetCategoryTourTypes {
  UPDATE_CATEGORY_TOUR_FAILURE = 'CATEGORY_TOUR_SUCCESS',

  RESET_CATEGORY_TOUR = 'RESET_CATEGORY_TOUR',

  CATEGORY_TOUR_FAILURE = 'CATEGORY_TOUR_FAILURE',
}
export enum getAllCategoryTourTypes {
  CATEGORY_TOUR_SUCCESS = 'CATEGORY_TOUR_SUCCESS',
  CATEGORY_TOUR_FAILURE = 'CATEGORY_TOUR_FAILURE',
}

export enum deleteCategoryTourTypes {
  CATEGORY_TOUR_DELETE_SUCCESS = 'CATEGORY_TOUR_DELETE_SUCCESS',
  CATEGORY_TOUR_DELETE_FAILURE = 'CATEGORY_TOUR_DELETE_FAILURE',
}
export enum GetCategoryTourByIdTypes {
  CATEGORY_TOUR_BYID_SUCCESS = 'CATEGORY_TOUR_BYID_SUCCESS',
  CATEGORY_TOURBYID_FAILURE = 'CATEGORY_TOURBYID_FAILURE',
}
